import { memo, useContext, useEffect, type FunctionComponent } from 'react';
// local imports
import { DataContext } from '../context';
import SkillsGrid from '../v3/SkillsGrid';

type TargetSkillsProps = {
  readonly supervisor?: boolean;
  readonly uid?: string | null;
  // non-empty => a manager is editing this employee's skill levels
  readonly selectedEmployeeId?: string | null;
  // display name of that employee, shown in the skill level dialog
  readonly selectedEmployeeName?: string | null;
}

const TargetSkills: FunctionComponent<TargetSkillsProps> = ({
  supervisor = false,
  uid,
  selectedEmployeeId,
  selectedEmployeeName
}) => {
  const {
    targetSkills: { data: skills, pending, failed },
    requireTargetSkills
  } = useContext(DataContext);

  useEffect(() => {
    requireTargetSkills?.();
  }, [uid, requireTargetSkills]);

  return (
    <SkillsGrid
        source="target"
        selectedEmployeeId={selectedEmployeeId}
        selectedEmployeeName={selectedEmployeeName}
        isEmployee={!supervisor}
        readOnly={supervisor}
        supervisor={supervisor}
        skills={skills}
        pending={pending}
        failed={failed}
    />
  );
};

export default memo(TargetSkills);
